import { Button, Space } from "antd";
import { ModalComponentProps } from "../../../types";
import UploadExcelModal from "../../common/UploadExcelModal";

export default function GrossSalaryModal({
  open,
  handleClose,
}: ModalComponentProps) {
  const handler = (data: FormData) => {
    console.log(data);
  };

  return (
    <UploadExcelModal
      open={open}
      handleClose={handleClose}
      isLoading={false}
      handler={handler}
      title="Import Attendance"
      warningText="Please ensure the data is accurate before uploading."
      footer={
        <Space size={12}>
          <Button
            className="normal-dark-button modal-button"
            onClick={handleClose}
            size="middle"
          >
            Cancel
          </Button>
          <Button className="modal-button" type="primary">
            Upload
          </Button>
        </Space>
      }
    />
  );
}
